export class Listener {
    chatEnd() { }
    chatStart() { }
    formNavigate(formName, formStep, navigationAction, data) { }
    formStart(formName, inputName) { }
    formSubmit(formName, data) { }
    setConsent(essential, functional, marketing) { }
    setCustomer() { }
    setExperimentVariation(experiment, variation) { }
    pageReady() { }
    scrollDistance(from, fromPercent, to, toPercent, distance, distancePercent, direction, duration, numEvent) { }
    scrollPercentage(percent) { }
}
